import { render } from "./Syndication.vue.js?vue&type=template&id=260d7bed!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Syndication.vue?vue&type=template&id=260d7bed"
import script from "./Syndication.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Syndication.vue?vue&type=script&lang=js"
export * from "./Syndication.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Syndication.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/stories/Syndication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "260d7bed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('260d7bed', __exports__)) {
    api.reload('260d7bed', __exports__)
  }
  
  module.hot.accept("./Syndication.vue.js?vue&type=template&id=260d7bed!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Syndication.vue?vue&type=template&id=260d7bed", () => {
    api.rerender('260d7bed', render)
  })

}


export default __exports__